import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

import useCatalogueData from "hook/useCatalogueData";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { TbPackageOff } from "react-icons/tb";
import ShimmerCatalogue from "components/shimmer/ShimmerCatalogue";

const Catalogue = () => {
  const scrollRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  const { catalogues, loadingCatalogue } = useCatalogueData();

  // Check scroll position
  const checkScroll = () => {
    if (scrollRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;

      setCanScrollLeft(scrollLeft > 0);
      setCanScrollRight(scrollLeft + clientWidth < scrollWidth - 1);
    }
  };

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    checkScroll(); // check immediately after mount or data load

    el.addEventListener("scroll", checkScroll);
    window.addEventListener("resize", checkScroll); // handle window resize

    return () => {
      el.removeEventListener("scroll", checkScroll);
      window.removeEventListener("resize", checkScroll);
    };
  }, [catalogues]);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = 250;
      scrollRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  if (loadingCatalogue)
    return (
      <ShimmerCatalogue />
    );

  if (!loadingCatalogue && catalogues.length === 0) {
    return (
      <div>
      </div>
    );
  }

  return (
    <section className="sm:mt-8 mt-5 px-4 sm:px-6">
      <div className="mb-4 flex items-end justify-between">
        <div>
          <h3 className="text-lg font-bold text-slate-900 sm:text-2xl">
            Shop By Category
          </h3>
          <p className="text-sm text-slate-600 sm:text-base">
            Explore catalogue pages by category.
          </p>
        </div>
      </div>

      <div className="flex snap-x gap-3 overflow-x-auto pb-2 [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden sm:gap-4">
        {catalogues.map((item) => (
          <div
            key={item.id}
            type="button"
            className="group shrink-0 snap-start overflow-hidden rounded-lg bg-white text-left shadow-sm transition duration-200 hover:-translate-y-0.5 hover:shadow-md w-[100px] sm:w-[190px] lg:w-[200px]"
          >
            <Link to={`/category/${item.catalogue_id}`}>
            <div className="relative h-20 w-full sm:h-28">
              <img
                src={`https://backend.nuhababy.com/${item.image_path}`}
                alt={item.title}
                className="h-full w-full object-fit transition duration-300 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/55 to-black/10" />
            </div>
            </Link>
            <div className="px-1 py-2.5">
              <span className="block text-[10px] sm:text-sm text-center font-semibold text-slate-800 truncate w-full">
                {item.title}
              </span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Catalogue;
